// ============================================================
// FIREBASE — initialized from environment variables (VITE_FIREBASE_*).
// NEVER hardcode real keys here. Copy `.env.example` to `.env.local` and fill
// in your project's firebaseConfig (see app/README.md).
//
// In P1 the app runs entirely on mockAdapter, so Firebase is OPTIONAL: if no
// env vars are present, `app`/`auth`/`db` stay null and nothing breaks. Once
// you switch DATA_BACKEND to 'firebase' (src/data/adapter.ts), these must be set.
// ============================================================
import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { getFunctions, type Functions } from 'firebase/functions';

/** Cloud Functions のリージョン（callable はこのリージョンにデプロイ）。 */
export const FUNCTIONS_REGION = 'asia-northeast1';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

/** True when the minimum Firebase config is present. */
export const isFirebaseConfigured = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId);

let app: FirebaseApp | null = null;
let auth: Auth | null = null;
let db: Firestore | null = null;
let functions: Functions | null = null;

if (isFirebaseConfigured) {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  // callable 関数は asia-northeast1 にデプロイされるので、同じリージョンに紐付ける。
  functions = getFunctions(app, FUNCTIONS_REGION);
}

export { app, auth, db, functions };
